// Base URL for API requests
export let ENVIRONMENT = "production";

if (process.env.NODE_ENV) {
  ENVIRONMENT = process.env.NODE_ENV;
}

export let BASEURL =
  ENVIRONMENT === "development"
    ? "http://localhost:3002/v1/"
    : "https://api.dantaniinc.com/v1/"; // Base URL for API requests
 BASEURL = "https://api.dantaniinc.com/v1/";

// Export all configurations
export default {
  BASEURL,
  ENVIRONMENT,
};
